import { Outlet, useParams } from 'react-router-dom';
// import { Code } from '@mantine/core';
import { useQuery } from '@apollo/client';
import TripDigestProvider from '@contexts/trip-digest-context';
import TripProfileState from '@components/trip-profile-state';
import GraphqlError from '@components/graphql-error';
import GraphqlNoData from '@components/graphql-bad-data';
import LoadingData from '@components/graphql-loading-data';
import { GET_TRIP_PROFILE_STATE } from '@queries/trip-profiles';

function TripProfile() {
  const { tripProfileId } = useParams();
  const { loading, error, data } = useQuery(GET_TRIP_PROFILE_STATE, {
    variables: {
      tripProfileId: tripProfileId || '',
    },
  });
  if (loading) return <LoadingData />;
  if (error) return <GraphqlError error={error} />;
  if (data && !(data.findQuestionStates.length === 0 || data.findQuestionStates.length === 6))
    return <GraphqlNoData data={data} />;

  return (
    <TripDigestProvider>
      {data && <TripProfileState fetchedStates={data.findQuestionStates} />}
      {data && <Outlet />}
      {/* <Code block>{JSON.stringify(data, null, 2)}</Code> */}
    </TripDigestProvider>
  );
}

export default TripProfile;
